import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'breadcrumbContainer',
    theme => `
		color: ${theme.survey.color.default};
		background-color: ${theme.survey.color.gray};
	`
  ],
  [
    'breadcrumb',
    `
		margin: 0 8px;
		padding: 6px 0;
		font-size: 13px;
		line-height: 1.4;
	`
  ]
]);
